import { For } from '../c-mp/comp/For'
import { Icon } from '../c-mp/comp/Icon'
import { $when, Show } from '../c-mp/comp/Show'
import { Slot } from '../c-mp/comp/Slot'
import { defineComponent } from '../c-mp/fun/defineComponent'
import { html } from '../c-mp/fun/html'
import { url } from '../c-mp/fun/url'
import { useEffect } from '../c-mp/fun/useEffect'
import { useQuery } from '../c-mp/fun/useQuery'
import { mutateState, useState } from '../c-mp/fun/useState'
import { andrisEmail } from '../fun/andrisEmail'
import { endOf } from '../fun/endOf'
import { expectDefined } from '../fun/expectDefined'
import { fetchPersonImagesList } from '../fun/fetchPersonImagesList'
import { formatDate } from '../fun/formatDate'
import { formatNumber } from '../fun/formatNumber'
import { getAge } from '../fun/getAge'
import { getBirthDateFallback } from '../fun/getBirthDateFallback'
import { getCouples } from '../fun/getCouples'
import { getDataOrThrow } from '../fun/getDataOrThrow'
import { getHalfSiblings } from '../fun/getHalfSiblings'
import { getLifeAndDeathFormatted } from '../fun/getLifeAndDeathFormatted'
import { getParentCouple } from '../fun/getParentCouple'
import { getPersonAliasesFormatted } from '../fun/getPersonAliasesFormatted'
import { getPersonIdFromUrl } from '../fun/getPersonIdFromUrl'
import { getPersonName } from '../fun/getPersonName'
import { getPersonNameFormatted } from '../fun/getPersonNameFormatted'
import { getSiblings } from '../fun/getSiblings'
import { getTodayIsoDate } from '../fun/getTodayIsoDate'
import { isDead } from '../fun/isDead'
import { isDivorced } from '../fun/isDivorced'
import { setPageTitle } from '../fun/setPageTitle'
import { ICON_COPY } from '../icon/ICON_COPY'
import { ICON_DIVORCED } from '../icon/ICON_DIVORCED'
import { ICON_EMAIL } from '../icon/ICON_EMAIL'
import { ICON_LEFT } from '../icon/ICON_LEFT'
import { ICON_MARRIED } from '../icon/ICON_MARRIED'
import { ICON_PHONE } from '../icon/ICON_PHONE'
import { ICON_PLUS } from '../icon/ICON_PLUS'
import { ICON_RIGHT } from '../icon/ICON_RIGHT'
import { ICON_TREE } from '../icon/ICON_TREE'
import { _ } from '../model/ccc'
import { PERSON_DETAILS } from '../model/PERSON_DETAILS'
import { QueryKey } from '../model/QueryKey'
import { PersonLinkComp } from './PersonLinkComp'
import { PortraitButtonComp } from './PortraitButtonComp'
import { PortraitComp, PortraitSize } from './PortraitComp'

export const PagePersonComp = defineComponent<{}>(
	'PagePersonComp',
	(props, $) => {
		useEffect('page title [ta77ls]', () => {
			setPageTitle(getPersonName(getPerson()))
		})

		const data = getDataOrThrow()

		function getPerson() {
			const personId = getPersonIdFromUrl()
			return personId ? data.personsById[personId] : undefined
		}

		const state = useState('state', {
			imageFileName: undefined as string | undefined,
		})

		const images = useQuery('images', () => ({
			key: QueryKey.Images,
			load: async ({ personId }: { personId: string | undefined }) => {
				if (!personId) return []
				return fetchPersonImagesList(personId)
			},
			params: { personId: getPersonIdFromUrl() },
			isEnabled: !!getPerson(),
			staleAfter: 1000 * 60 * 30,
		}))

		useEffect('images loaded [tbbusk]', () => {
			setSelectedFileName(images.data?.at(-1))
		})

		function getSelectedFileName() {
			return state.imageFileName && images.data?.includes(state.imageFileName)
				? state.imageFileName
				: images.data?.at(-1)
		}
		function setSelectedFileName(value: string | undefined) {
			if (value) {
				mutateState(
					$.debugName,
					'set selected image file name [t9mwd7]',
					() => {
						state.imageFileName = value
					},
				)
			}
		}
		function getPreviousFileName() {
			const current = getSelectedFileName()
			if (current && images.data) {
				const index = images.data.indexOf(current)
				if (index > 0) {
					return images.data.at(index - 1)
				}
			}
		}
		function getNextFileName() {
			const current = getSelectedFileName()
			if (current && images.data) {
				const index = images.data.indexOf(current)
				return images.data.at(index + 1)
			}
		}

		return (
			<Show
				else={() => (
					<div class={_.ccc_page}>
						<h1>Ez a személy nem található</h1>
					</div>
				)}
				it={$when(getPerson, ({ get: getPerson }) => (
					<>
						<div class={_.ccc_portrait_container}>
							<button
								class={_.ccc_button__plus}
								title='Előző kép'
								disabled={() => !getPreviousFileName()}
								onclick={() => {
									setSelectedFileName(getPreviousFileName())
								}}
							>
								<Icon svg={ICON_LEFT} />
							</button>
							<PortraitComp
								getPerson={getPerson}
								getFileName={getSelectedFileName}
								getSize={() => PortraitSize.Large}
							/>
							<button
								class={_.ccc_button__plus}
								title='Következő kép'
								disabled={() => !getNextFileName()}
								onclick={() => {
									setSelectedFileName(getNextFileName())
								}}
							>
								<Icon svg={ICON_RIGHT} />
							</button>
						</div>
						<div class={_.ccc_page}>
							<div class={_.ccc_date}>
								<Slot
									isTrustedHtml
									get={() => {
										const date = getSelectedFileName()?.replace(/\..*/, '')
										if (date) {
											return html`A kép dátuma ${formatDate(date)} –
												<b
													>${formatNumber(
														getAge(getPerson().birthDate, endOf(date)),
													) ?? '?'}
													éves</b
												>`.toString()
										} else {
											return `&nbsp;`
										}
									}}
								/>
							</div>
							<div class={_.ccc_tiles__centered__compact}>
								<For
									debugName='Előnézetek'
									each={() => images.data}
									render={({ get }) => (
										<PortraitButtonComp
											getPerson={getPerson}
											getFileName={get}
											getSelectedFileName={getSelectedFileName}
											setSelectedFileName={setSelectedFileName}
										/>
									)}
									empty={() => (
										<button
											class={[
												_.ccc_button__person,
												_.ccc__selected,
												_.ccc__hidden,
											]}
										>
											<PortraitComp getPerson={getPerson} />
										</button>
									)}
								/>
							</div>
							<h1>
								<Slot get={() => getPersonNameFormatted(data, getPerson())} />
							</h1>
							<Show
								it={$when(
									() => getPerson().aliases,
									({ get }) => (
										<p>
											<small class={_.ccc_color_secondary}>Más néven:</small>{' '}
											<Slot get={() => getPersonAliasesFormatted(get())} />
										</p>
									),
								)}
							/>
							<p class={_.ccc_date_large}>
								<Slot get={() => getLifeAndDeathFormatted(data, getPerson())} />
							</p>
							<p>
								<Slot
									get={() => {
										const person = getPerson()
										if (isDead(data, person)) {
											if (person.birthDate && person.deathDate) {
												return `${
													getAge(
														getPerson().birthDate,
														getPerson().deathDate,
													) ?? '?'
												} éves korában elhunyt ${person.info ?? ''}`
											} else {
												return undefined
											}
										} else {
											return `${getAge(getPerson().birthDate) ?? '?'} éves ${person.info ?? ''}`
										}
									}}
								/>
							</p>
							<div class={_.ccc_tiles__centered__compact}>
								<a
									class={_.ccc_button__rounded}
									href={() => url`/person/${getPerson().id}/tree`}
								>
									<Icon svg={ICON_TREE} /> <b>Családfa rajza</b>
								</a>
								<a
									class={_.ccc_button__rounded}
									href={() => url`/person/${getPerson().id}/contemporaries`}
								>
									Kortársai
								</a>
								<Show
									it={$when(
										() =>
											!isDead(data, getPerson()) &&
											(getAge(getBirthDateFallback(data, getPerson()).value) ??
												18) >= 18,
										() => (
											<>
												<Show
													it={$when(
														() => getPerson().email,
														({ get }) => (
															<a
																class={_.ccc_button__rounded}
																href={() => url`mailto:${get()}`}
															>
																<Icon svg={ICON_EMAIL} /> Email
															</a>
														),
													)}
													else={() => (
														<div class={[_.ccc_button_padding, _.ccc_unknown]}>
															<Icon svg={ICON_EMAIL} /> Email?
														</div>
													)}
												/>
												<Show
													it={$when(
														() => getPerson().phone,
														({ get }) => (
															<a
																class={_.ccc_button__rounded}
																href={() => url`tel:${get()}`}
															>
																<Icon svg={ICON_PHONE} /> Telefon
															</a>
														),
													)}
													else={() => (
														<div class={[_.ccc_button_padding, _.ccc_unknown]}>
															<Icon svg={ICON_PHONE} /> Telefon?
														</div>
													)}
												/>
											</>
										),
									)}
								/>
								<button
									class={_.ccc_button__rounded}
									onclick={() => {
										navigator.clipboard.writeText(getPerson().id)
									}}
									title='Azonosító másolása'
								>
									<Icon svg={ICON_COPY} /> Azonosító
								</button>
								<a
									class={_.ccc_button__rounded}
									href={() =>
										andrisEmail(
											`Szerkesztés: ${getPersonName(getPerson())}`,
											`És szeretném a következő változatatásokat kérni:\n\n${PERSON_DETAILS}`,
										)
									}
									title='Adatok szerkesztése'
								>
									<Icon svg='<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="currentColor" d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5L13.5 4.793L14.793 3.5L12.5 1.207zm1.586 3L10.5 3.207L4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175l-.106.106l-1.528 3.821l3.821-1.528l.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325"/></svg>' />{' '}
									Szerkesztés
								</a>
								<a
									class={_.ccc_button__plus}
									href={() =>
										andrisEmail(
											`Fénykép: ${getPersonName(getPerson())}`,
											`A fényképeket ide töltöttem föl: \n\nA fényképek dátumai a következők: `,
										)
									}
									title='Kép hozzáadása'
								>
									<Icon svg={ICON_PLUS} /> Kép
								</a>
							</div>
							<h2>Szülei</h2>
							<Show
								it={$when(
									() => {
										const it = getParentCouple(data, getPerson().id)
										return it && (it.maleId || it.femaleId) ? it : undefined
									},
									({ get: getCouple }) => (
										<div class={_.ccc_couple}>
											<div class={_.ccc_tiles__centered}>
												<Show
													it={$when(
														() => {
															const maleId = getCouple().maleId
															return maleId
																? expectDefined(data.personsById[maleId])
																: undefined
														},
														({ get }) => (
															<div class={_.ccc_tiles__centered}>
																<strong class={_.ccc_button_padding_y}>
																	Apja:
																</strong>
																<PersonLinkComp get={get} />
															</div>
														),
													)}
												/>{' '}
												<Show
													it={$when(
														() => {
															const femaleId = getCouple().femaleId
															return femaleId
																? expectDefined(data.personsById[femaleId])
																: undefined
														},
														({ get }) => (
															<div class={_.ccc_tiles__centered}>
																<strong class={_.ccc_button_padding_y}>
																	Anyja:
																</strong>
																<PersonLinkComp get={get} />
															</div>
														),
													)}
												/>
											</div>
										</div>
									),
								)}
								else={() => <span class={_.ccc_unknown}>?</span>}
							/>
							<h2>Testvérei</h2>
							<div class={_.ccc_tiles__centered}>
								<For
									debugName='Testvérei'
									each={() => getSiblings(data, getPerson().id)}
									render={PersonLinkComp}
									empty={() => <>–</>}
								/>
							</div>
							<h2>Féltestvérei</h2>
							<div class={_.ccc_tiles__centered}>
								<For
									debugName='Féltestvérei'
									each={() => getHalfSiblings(data, getPerson().id)}
									render={PersonLinkComp}
									empty={() => <>–</>}
								/>
							</div>
							<h2>Házasságkötései</h2>
							<For
								debugName='Házasságkötései'
								each={() => getCouples(data, getPerson().id)}
								render={({ get }) => (
									<div class={_.ccc_couple}>
										<p class={_.ccc_date_of_marriage}>
											<Slot
												isTrustedHtml
												get={() =>
													isDivorced(get()) ? ICON_DIVORCED : ICON_MARRIED
												}
											/>{' '}
											<b>
												<Slot
													get={() =>
														formatDate(get().marriedDate) ?? (
															<span class={_.ccc_unknown}>
																Ismeretlen időpontban
															</span>
														)
													}
												/>
											</b>
											<Show
												it={$when(
													() => get().marriedPlace,
													($) => (
														<>
															{' '}
															<small>
																(<Slot get={() => get().marriedPlace} />)
															</small>
														</>
													),
												)}
												else={() => (
													<>
														{' '}
														<span class={_.ccc_unknown}>
															(Ismeretlen helyen)
														</span>
													</>
												)}
											/>
											<Show
												it={$when(
													() => isDivorced(get()),
													() => (
														<>
															{' '}
															–{' '}
															<b>
																<Slot
																	get={() =>
																		formatDate(get().divorcedDate) ?? (
																			<span class={_.ccc_unknown}>
																				Ismeretlen időpontban
																			</span>
																		)
																	}
																/>
															</b>
															<Show
																it={$when(
																	() => get().divorcedPlace,
																	() => (
																		<>
																			{' '}
																			<small>
																				(
																				<Slot get={() => get().divorcedPlace} />
																				)
																			</small>
																		</>
																	),
																)}
																else={() => (
																	<>
																		{' '}
																		<span class={_.ccc_unknown}>
																			(Ismeretlen helyen)
																		</span>
																	</>
																)}
															/>
														</>
													),
												)}
											/>
											<Show
												it={$when(
													() => get().marriedDate && getPerson().birthDate,
													() => (
														<>
															<br />
															<span class={_.ccc_date}>
																<b>
																	<Slot
																		get={() =>
																			formatNumber(
																				getAge(
																					getPerson().birthDate,
																					get().marriedDate,
																				),
																			)
																		}
																	/>{' '}
																	évesen
																</b>
																<Show
																	it={$when(
																		() => isDivorced(get()),
																		() => (
																			<>
																				{' '}
																				– elvált{' '}
																				<b>
																					<Slot
																						get={() =>
																							formatNumber(
																								getAge(
																									getPerson().birthDate,
																									get().divorcedDate,
																								),
																							)
																						}
																					/>{' '}
																					évesen
																				</b>
																			</>
																		),
																	)}
																	else={() => (
																		<>
																			{' '}
																			–{' '}
																			<b>
																				<Slot
																					get={() =>
																						formatNumber(
																							getAge(
																								get().marriedDate,
																								getTodayIsoDate(),
																							),
																						)
																					}
																				/>{' '}
																				éve
																			</b>
																		</>
																	)}
																/>
															</span>
														</>
													),
												)}
											/>
										</p>
										<div class={_.ccc_tiles__centered}>
											<strong class={_.ccc_button_padding_y}>Párja:</strong>{' '}
											<Show
												it={$when(() => {
													const otherId = getPerson().isMale
														? get().femaleId
														: get().maleId
													if (otherId)
														return expectDefined(data.personsById[otherId])
													else return undefined
												}, PersonLinkComp)}
												else={() => (
													<span class={[_.ccc_unknown, _.ccc_button_padding_y]}>
														?
													</span>
												)}
											/>
										</div>
										<div class={_.ccc_tiles__centered}>
											<strong class={_.ccc_button_padding_y}>Gyermekei:</strong>{' '}
											<For
												debugName={`Gyerekek`}
												each={() =>
													get().childIds?.map((it) =>
														expectDefined(data.personsById[it]),
													)
												}
												render={PersonLinkComp}
												empty={() => (
													<span class={_.ccc_button_padding_y}>–</span>
												)}
											/>
										</div>
									</div>
								)}
								empty={() => <p>–</p>}
							/>
						</div>
					</>
				))}
			/>
		)
	},
)
